// extracted by mini-css-extract-plugin
export var closeButton = "_fj-2";
export var closeButtonIcon = "_fj-3";
export var lightboxContent = "_fj-1";
export var lightboxOverlay = "_fj-0";